import { RouteRecordRaw } from 'vue-router'

import CalendarView from '@/pages/guest/CalendarView.vue'
import PurchasePolicy from '@/pages/guest/PurchasePolicy.vue'
import SetShow from '@/pages/guest/SetShow.vue'
import ShowDetails from '@/pages/guest/ShowDetails.vue'
import TermsConditions from '@/pages/guest/TermsConditions.vue'

export const ssrRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'setShow',
    component: SetShow,
    meta: {
      guest: true,
      header: true,
      pageTitle: 'Show List',
    },
  },
  {
    path: '/shows/:showId/',
    name: 'showDetails',
    component: ShowDetails,
    meta: {
      guest: true,
      header: true,
      pageTitle: 'Show Detail',
    },
  },
  {
    path: '/events',
    name: 'calendar',
    component: CalendarView,
    meta: {
      guest: true,
      header: true,
      pageTitle: 'Calendar',
    },
  },
  {
    path: '/terms-conditions',
    name: 'terms-conditions',
    component: TermsConditions,
    meta: {
      header: true,
      guest: true,
      pageTitle: 'Terms and Conditions of Use',
      since: 'RLF 2022-08-23',
    },
  },
  {
    path: '/purchase-policy',
    name: 'purchase-policy',
    component: PurchasePolicy,
    meta: {
      header: true,
      guest: true,
      pageTitle: 'Purchase Policy',
      since: 'RLF 2022-10-11',
    },
  },
]
